import { Box, css } from '@mui/material'
import styled from '@emotion/styled'

export const FilterButtons = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: flex-end;
    gap: 16px;
    /* Última coluna do grid → botões alinhados à direita */
    grid-column: -2 / -1;

    @media (max-width: ${theme.screenSizes.laptop}) {
      margin-top: 16px;
      flex-direction: column-reverse;
      align-items: center;
    }
  `}
`
